import { useState } from 'react';

export const useClipboard = (timeout = 2000) => {
    const [hasCopied, setHasCopied] = useState(false);

    const copyToClipboard = async (text) => {
        if (!navigator.clipboard) {
            console.warn("Clipboard API not available");
            return;
        }

        try {
            await navigator.clipboard.writeText(text);
            setHasCopied(true);
            setTimeout(() => setHasCopied(false), timeout);
        } catch (error) {
            console.error("Copy failed", error);
            setHasCopied(false);
        }
    };

    return { hasCopied, copyToClipboard };
};
